export default __webpack_public_path__ + "assets/img/eye view.402638d7.svg";